<template>
    <div class="bottom">
        <p class="mt30">浙江日报报业集团</p>
        <p class="flex aic jcc pb30">©浙江智慧网络医院管理有限公司版权所有&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;工信部备案号&nbsp;&nbsp;
            <a href="http://www.beian.miit.gov.cn/">浙ICP备17007984号-1</a>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<img src="../assets/icon_police_2763990@2x.png" alt="">&nbsp;&nbsp;
            浙公安网备 <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010302003380">33010302003380</a></p>
    </div>
</template>

<script>
    export default {
        name: "login-footer"
    }
</script>

<style scoped lang="scss">
    .bottom {
        p {
            font-size: 14px;
            text-align: center;
            color: rgba(153, 153, 153, 1);
        }

        p + p {
            margin-top: 10px;
        }
    }
</style>
